import { useStyles } from '@archipro-design/aria';
import { COLUMN_WIDTH_100 } from '@modules/page-builder/config/column-constants';
import type { ImageColumnProps } from '@modules/page-builder/types';
import DetailSingleImage from '../detail-single-image-shell/DetailSingleImageShell';
import { SingleImageContainer } from '../../common/pagebuilder-article.style';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import ImageWithPaintPickerArticle from '../../common/image-with-paint-picker/ImageWithPaintPickerArticle';
import { ImageModuleExtraSpacing } from '@modules/page-builder/component/detail-article/detail-modules/DetailModules.style';

interface SingleImageModuleProps {
    column: ImageColumnProps;
}

const SingleImageModule = ({ column }: SingleImageModuleProps) => {
    const { css } = useStyles();

    if (!column.imageUrl) {
        return null;
    }

    return (
        <div className={css(SingleImageContainer, ImageModuleExtraSpacing)}>
            <DetailSingleImage
                caption={column.caption}
                libraryImage={column?.libraryImage}
                tags={column.tags}
                uniqueApprovedTags={column.uniqueApprovedTags}
                imageURL={column.imageUrl}
                dimension={column.dimension}
                columnId={column.id}
            >
                <ImageWithPaintPickerArticle
                    src={column.imageUrl}
                    width={column.dimension.width}
                    height={column.dimension.height}
                    layout={'fill'}
                    objectFit={'cover'}
                    sizes={getImagesSizes(COLUMN_WIDTH_100)}
                    alt={column.caption || column?.libraryImage?.Title || ''}
                />
            </DetailSingleImage>
        </div>
    );
};

export default SingleImageModule;
